import { useState } from 'react';

import { AppInfo } from 'api-bible-shared-lib/utils/types';
import { Alert, AlertType } from '../components/Alert';
import Container from '../components/Container';
import Card from '../components/Card';
import ApplicationForm from '../components/ApplicationForm';
import { AppHeader } from '../components/AppHeader';

import { useApplications } from '../contexts/Applications';

export default function ApplicationSettings({ appId }: { appId: string }) {
  const { applicationsById, editApplication } = useApplications();
  const app = applicationsById[appId];

  const [error, setError] = useState<Error | undefined>(undefined);
  const [success, setSuccess] = useState<string | undefined>(undefined);

  if (!app) return null; // can't arrive here since router will redirect

  const handleSubmit = async (data: AppInfo) => {
    setSuccess(undefined);
    setError(undefined);

    try {
      await editApplication(appId, data);
      setSuccess('Your app was successfully updated.');
    } catch (e) {
      const err = e as Error;
      setError(err);
    }
  };

  return (
    <Container>
      <AppHeader
        appLinkBasePath="/application"
        currentAppId={appId}
        currentAppMenuItem="settings"
      />
      <div className="flex justify-between mb-4">
        <Card className="p-12">
          {success && (
            <Alert className="mb-8" type={AlertType.SUCCESS} title="Success!" message={success} />
          )}

          {error && (
            <Alert
              className="mb-8"
              type={AlertType.ERROR}
              title="There was an error with your submission"
              message={error?.message || 'An unexpected error occurred.'}
            />
          )}

          <ApplicationForm
            key={app.id}
            handleSubmit={handleSubmit}
            initialAppValues={app}
            submitText="Save Changes"
          />
        </Card>
      </div>
    </Container>
  );
}
